<template>
  <section>
    <div class="wrapper">
      <div class="cmdp_b">
        <div class="b_top" :style="{ background : `url(${bTop}) no-repeat 80% 2%`}">
          <div class="m_text01">{{ userInfo.userNm }}님 안녕하세요</div>
          <div class="m_text02">진행상태를 확인해보세요</div>
          <div class="box_btn_swipe">
            <ul class="scroll">
              <li v-if="sendStatusList2.length > 0" v-for="item of sendStatusList2"
                  @click="filterData.status = item.cdId; commonOnChangeEvent();"
                  :class="{on: item.cdId === filterData.status}"
              >{{ item.cdNm }}</li>
            </ul>
          </div>
        </div>
        <div class="main_list">
          <div class="w10 f_r" @click="showFilter(true)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon_filter">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5" />
            </svg>
          </div>
          <div class="box_flex main_search">
            <div class="w85">
              <input placeholder="수신인, 운송장 번호를 검색하세요" v-model="filterData.textData" class="">
            </div>
            <div class="w15 txt_c" @click="commonOnChangeEvent">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon_search">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
              </svg>
            </div>
          </div>
          <div class="filter_state">
            <ul>
              <li v-if="computedClear" @click="onClearFilter">초기화</li>
              <li v-if="!!filterData.frstRgstDtRange">{{ computedFrstRgstDtRange }}</li>
              <li v-if="!!filterData.steadYn">{{ computedSteadYn }}</li>
              <li v-if="!!filterData.sendScn">{{ computedSendScn }}</li>
            </ul>
          </div>
          <div v-if="!!sendInfoList && sendInfoList.length < 1" class="box_nodata">
            <img class="img_nodata" src="@/assets/img/etners-web/img_receipt_complete_noproduct.png">
            <div>최근 {{ computedFrstRgstDtRange }} 이내에 신청하신 발송 내역이 없습니다.</div>
          </div>
          <div v-else class="reservation_state">
            <ul>
              <li v-for="sendInfo in sendInfoList"
                  :class="{ disabled: sendInfo.statusNm === '발송취소'}"
                  @mousedown="onMouseDown($event)"
                  @mouseup="onMouseUp(sendInfo.sendId)"
                  @mousemove="onMouseMove">
                <div>
                  <div v-if="sendInfo.sendScn === '01'" class="main_rbox registered">
                    등기
                  </div>
                  <div v-else-if="sendInfo.sendScn === '02'" class="main_rbox parcel">
                    국내<br>택배
                  </div>
                  <div v-else-if="sendInfo.sendScn === '03'" class="main_rbox airmail">
                    해외<br>특송
                  </div>
                  <div v-else class="main_rbox">
                    확인<br>불가
                  </div>
                  <div class="right_text">
                    <div v-if="sendInfo.status==='00'" class="deliverystatus process03 process_icon">{{ sendInfo.statusNm }}</div>
                    <div v-else-if="sendInfo.status==='01'" class="deliverystatus process01 process_icon">{{ sendInfo.statusNm }}</div>
                    <div v-else-if="sendInfo.status==='02'" class="deliverystatus process02 process_icon">{{ sendInfo.statusNm }}</div>
                    <div v-else-if="sendInfo.status==='04'" class="deliverystatus process03 process_icon">{{ sendInfo.statusNm }}</div>
                    <div v-else-if="sendInfo.status==='05'" class="deliverystatus process04 process_icon">{{ sendInfo.statusNm }}</div>
                    <div v-else-if="sendInfo.status==='98'" class="deliverystatus process07 process_icon">{{ sendInfo.statusNm }}</div>
                    <div v-else-if="sendInfo.status==='99'" class="deliverystatus process08 process_icon">{{ sendInfo.statusNm }}</div>
                    <div v-else class="deliverystatus process08 process_icon">{{ sendInfo.statusNm }}</div>
                    <div class="name">{{ !!sendInfo.receiveNm ? sendInfo.receiveNm : '수신자명 미작성' }}</div>
                    <div v-if="sendInfo.steadYn === 'Y'" class="deputy">대리발송 : {{ sendInfo.steadNm }}</div>
                    <div v-else class="deputy">
                      <!-- 본인 : {{ sendInfo.steadNm }} -->
                    </div>
                    <div class="waybill ">{{ !!sendInfo.blNo ? sendInfo.blNo : '운송장 번호가 등록되지 않았습니다' }}</div>
                    <div class="date">{{ sendInfo.frstRgstDt }}</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="bottom_menu">
          <div class="registered" @click="redirectToSave('01')">등기예약</div>
          <div class="airmail" @click="redirectToSave('03')">해외특송 예약</div>
          <div class="parcel" @click="redirectToSave('02')">국내 택배예약</div>
        </div>
      </div>

      <!-- 검색 조건 -->
      <div v-show="isShowFilter" class="box_filter">
        <reserve-list-filter
            ref="filterWindowRef"
            :oldFilterData="filterData"
            @showFilter="showFilter"
            @setFilter="setFilter"
        ></reserve-list-filter>
      </div>
      <div class="dimmed" style="display:none"></div>
    </div>
  </section>
</template>
<script>
import ReserveListFilter from "@/components/mobile/ReserveListFilter";
import {LogisticsCodeDtlMixin} from "@/mixin/Mixin";
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import EtnersDateTimeUtil from "@/common/etners.datetime.util";
import $ from 'jquery'

export default {
  name: "ReserveList",
  mixins: [LogisticsCodeDtlMixin],
  components: {ReserveListFilter},
  created() {
    const vm = this
    const jsonStrLastRouteParams = sessionStorage.getItem('LAST_ROUTE_PARAMS')
    const lastRouteParams = sessionStorage.getItem('LAST_ROUTE_NAME') === 'ReserveDetail' ? (jsonStrLastRouteParams === undefined ? [] : JSON.parse(jsonStrLastRouteParams)) : []

    vm.filterData = {
      ...vm.filterData,
      ...lastRouteParams
    }

    // 그리드 데이터
    this.getListData()
  },
  mounted() {
    this.getListData()
    this.setRowScroll()
  },
  computed: {
    computedClear () {
      const vm = this
      return (!!vm.filterData.sendScn || !!vm.filterData.steadYn || !!vm.filterData.frstRgstDtRange)
    },
    computedSendScn () {
      const vm = this
      let sendScn =  vm.sendScnList.filter(item =>
        item.cdId === vm.filterData.sendScn
      )
      return sendScn[0].cdNm
    },
    computedSteadYn () {
      const vm = this
      let steadYn =  vm.steadYnList.filter(item =>
          item.cdId === vm.filterData.steadYn
      )
      return steadYn[0].cdNm
    },
    computedFrstRgstDtRange () {
      const vm = this
      const frstRgstDtRange = vm.filterData.frstRgstDtRange
      if(!!!vm.filterData.frstRgstDtRange) {
        return '-'
      }
      let text = frstRgstDtRange.replace('w', '주일').replace('m', '개월')
      return text
    }
  },
  methods: {
    setRowScroll() {
      $(".scroll").on('wheel',function(event){
        event.stopPropagation()
        event.stopImmediatePropagation()

        let wheelDelta = event.originalEvent.wheelDelta;

        if(wheelDelta > 0){
          $(this).scrollLeft(-wheelDelta + $(this).scrollLeft());
        }else{
          $(this).scrollLeft(-wheelDelta + $(this).scrollLeft());
        }
        // 외부 스크롤 이벤트 막기
        return false;
      });

    },
    getFilterData () {
      const vm = this
      let currentSearchDataObj = { ...vm.filterData }

      if(!!!vm.filterData.status) {
        currentSearchDataObj.status = vm.filterData.status
      }
      if(vm.filterData.frstRgstDtStartDt !== undefined){
        if(!!vm.filterData.frstRgstDtStartDt){
          if (vm.filterData.frstRgstDtStartDt instanceof Date) {
            currentSearchDataObj.frstRgstDtStartDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(vm.filterData.frstRgstDtStartDt, '/')
          }else {
            currentSearchDataObj.frstRgstDtStartDt = vm.filterData.frstRgstDtStartDt
          }
        }
      }
      if(vm.filterData.frstRgstDtEndDt !== undefined){
        if(!!vm.filterData.frstRgstDtEndDt){
          if (vm.filterData.frstRgstDtStartDt instanceof Date) {
            currentSearchDataObj.frstRgstDtEndDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(vm.filterData.frstRgstDtEndDt, '/')
          }else {
            currentSearchDataObj.frstRgstDtEndDt = vm.filterData.frstRgstDtEndDt
          }
        }
      }

      return currentSearchDataObj
    },

    getListData () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/reserveSend/sendReserveList.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        ...vm.getFilterData(),
      }
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('정상적으로 처리되지 않았습니다.')
          return false
        }
        sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(param))
        vm.sendInfoList = response.data.resultData
      })

    },

    showFilter (isShowFilter) {
      const vm = this
      vm.isShowFilter = isShowFilter
    },

    setFilter (newFilterData) {
      // 검색창 확인
      const vm = this
      vm.filterData = {...newFilterData}
      vm.showFilter(false)
      vm.commonOnChangeEvent()
    },

    onClearFilter () {
      const vm = this
      vm.filterData = {
        textData: null,
        frstRgstDtStartDt: new Date(new Date().setMonth(vm.now.getMonth() - 1)),
        frstRgstDtEndDt: vm.now,
        frstRgstDtRange: '1m',
        steadYn: '',
        sendScn: ''
      }
      vm.commonOnChangeEvent()
    },

    commonOnChangeEvent () {
      const vm = this
      vm.getListData()
    },

    redirectToDetail (sendId) {
      this.$router.push({
        name: 'ReserveDetail',
        params: {
          sendId : sendId
        }
      })
    },

    redirectToSave (sendScn) {
      this.$router.push({
        name: 'ReserveUpsert',
        params: {
          sendScn: sendScn
        }
      })
    },

    onMouseDown(e) {
      this.isDragging = false
      this.dragStart = { x: e.clientX, y: e.clientY }
    },

    onMouseMove(e) {
      const dx = Math.abs(e.clientX - this.dragStart.x)
      const dy = Math.abs(e.clientY - this.dragStart.y)
      if (dx > this.dragThreshold || dy > this.dragThreshold) {
        this.isDragging = true
      }
    },
    onMouseUp(sendId) {
      if (!this.isDragging) {
        this.redirectToDetail(sendId)
      }
    },
  },
  data () {
    const vm = this
    const now = new Date()
    return {
      loginUserToken: sessionStorage.getItem('ssoUserToken'),
      steadYnList: [{cdId: '', cdNm: '전체'}, {cdId: 'N', cdNm: '본인'}, {cdId: 'Y', cdNm: '대리'}],
      userInfo: JSON.parse(sessionStorage.getItem('loginUserData')),
      isShowFilter: false,
      sendInfoList: [],
      now: now,

      filterData: {
        status: '',
        textData: null,
        frstRgstDtStartDt: new Date(new Date().setMonth(now.getMonth() - 1)),
        frstRgstDtEndDt: now,
        frstRgstDtRange: '1m',
        steadYn: '',
        sendScn: ''
      },
      // css
      bTop: require(`@/assets/img/etners-main/logistics_eten.png`),

      dragStart: { x: 0, y: 0 },
      isDragging: false,
      dragThreshold: 5,
    }
  }
}
</script>

<style scoped>
  /*@import "https://tf-design.etnersplatform.com/cmdp/re_cmdp.css";*/
</style>
